/**
 * Formatação e regras de exibição do módulo de seguros.
 *
 * A urgência NUNCA é decidida aqui: o backend calcula urgencyBucket e
 * daysUntilExpiration a partir da data de fim de vigência (cron diário das
 * 06:00, ver OpportunityService/urgencyBucket.ts) e devolve os cards já
 * ordenados. Este arquivo só traduz esses valores em cor e texto.
 */

export const URGENCY_CONFIG = {
  vencida: { label: "Vencida", color: "#C62828" },
  urgente: { label: "Urgente", color: "#EF6C00" },
  atencao: { label: "Atenção", color: "#F9A825" },
  normal: { label: "No prazo", color: "#5C6BC0" },
};

export const URGENCY_ORDER = ["vencida", "urgente", "atencao", "normal"];

/**
 * Stages em que o card já saiu do fluxo de renovação. Espelha TERMINAL_STAGES
 * de UpdateOpportunityStageService.ts.
 *
 * Neles a faixa de urgência é substituída por um selo do próprio stage: a
 * urgência deriva da vigência da apólice ANTIGA e mover o card não cria
 * apólice nova, então um card em "Renovada" seguia exibindo "Vencida /
 * venceu há X dias". O dado não está errado, está incompleto — some quando
 * existir confirmação formal de renovação (Requisito A + Etapa 3 do PDF).
 */
export const TERMINAL_STAGES = ["renovada", "perdido_concorrente", "cancelado"];

export const STAGE_BADGE = {
  renovada: { label: "Renovada", color: "#2E7D32" },
  perdido_concorrente: { label: "Perdido", color: "#757575" },
  cancelado: { label: "Cancelado", color: "#757575" },
};

export const isTerminalStage = (stage) => TERMINAL_STAGES.includes(stage);

export const stageBadgeColor = (stage) =>
  (STAGE_BADGE[stage] || STAGE_BADGE.cancelado).color;

export const stageBadgeLabel = (stage) =>
  (STAGE_BADGE[stage] || STAGE_BADGE.cancelado).label;

export const urgencyColor = (bucket) =>
  (URGENCY_CONFIG[bucket] || URGENCY_CONFIG.normal).color;

export const urgencyLabel = (bucket) =>
  (URGENCY_CONFIG[bucket] || URGENCY_CONFIG.normal).label;

/** Texto curto de prazo, a partir dos dias que o backend já calculou. */
export const expirationLabel = (days) => {
  if (days === null || days === undefined) return "";
  if (days < 0) {
    const elapsed = Math.abs(days);
    return elapsed === 1 ? "venceu ontem" : `venceu há ${elapsed} dias`;
  }
  if (days === 0) return "vence hoje";
  if (days === 1) return "vence amanhã";
  return `vence em ${days} dias`;
};

/**
 * "2026-09-18" -> "18/09/2026" sem passar por Date: new Date("2026-09-18")
 * é interpretado como UTC e, no fuso do Brasil, volta um dia.
 */
export const formatDateOnly = (value) => {
  if (!value) return "—";
  const [year, month, day] = String(value).slice(0, 10).split("-");
  if (!year || !month || !day) return "—";
  return `${day}/${month}/${year}`;
};

const currencyFormatter = new Intl.NumberFormat("pt-BR", {
  style: "currency",
  currency: "BRL",
});

export const formatCurrency = (value) => {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return "—";
  return currencyFormatter.format(parsed);
};

/** Contato criado pela conciliação sem telefone real — não dá para conversar. */
export const hasRealPhone = (contact) =>
  Boolean(contact && contact.number && !String(contact.number).startsWith("SEM-WHATSAPP-"));
